import axios from 'axios'
import React from 'react';
import { Redirect } from 'react-router-dom';
import * as const_function from './const_function';
import { LoginResponse, } from "./../dto/auth.dto";
import { ResponseApiApp, ResponseListApiApp } from './../dto/responseApi.dto';
axios.defaults.withCredentials = true;
const apiUrl = process.env.REACT_APP_API_URL;

const upload_headers = {
    'accept': '*/*',
    'Content-Type': 'multipart/form-data',
    'Authorization': 'Bearer ' + const_function.getToken()
}
export function signOut() {
    const_function.clearSession();
    return <Redirect to='/login' push={false} />
}
export function multiple(array: any, callback: any) {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + const_function.getToken()
    } 
    let requestArray = array.map((path: any) => axios.get(`${apiUrl}/${path}`, { headers: headers }))
    axios.all(requestArray)
        .then(result => {
            // console.log(result)
            callback(result, 100)
        })
        .catch(err => {
            if (err.response && err.response.status === 403) {
                callback(false, 403)
            } else {
                callback(false, 500)
            }
        })
}

export function GetListRequest<T>(route: any, params: any, authData?: LoginResponse): Promise<ResponseListApiApp<T>> {
    return new Promise(resolve => {

        var headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'accept': 'application/json'
        } as any;
        if (authData) {
            headers.authorization = "Bearer " + authData.token;
            //   headers.uid = authData.customerId;
        }
        const requestOptions = {
            method: 'GET',
            headers: headers,
            params: params
        };
        fetch(`${apiUrl}/${route}`, requestOptions)
            .then(response => response.json())
            .then(result => {
            
                return resolve({ items: result.items,totalCount:result.totalCount, success: true })
            })
            .catch(err => {
                console.log(err)
                if (err.response && err.response.status === 403) {
                    return resolve({ success: false, items:[] , message: err.response })
                } else {
                    return resolve({ success: false, items: [] , message: "" })
                }
            })
    });
};
export function GetRequest(route: any, params: any, authData?: LoginResponse): Promise<ResponseApiApp<any>> {
    return new Promise(resolve => {

        var headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'accept': 'application/json'
        } as any;
        if (authData) {
            headers.authorization = "Bearer " + authData.token;
            //   headers.uid = authData.customerId;
        }
        const requestOptions = {
            method: 'GET',
            headers: headers,
            params: params
        };
        fetch(`${apiUrl}/${route}`, requestOptions)
            .then(response => response.json())
            .then(result => {

                return resolve(result)
            })
            .catch(err => {
                console.log(err)
                if (err.response && err.response.status === 403) {
                    return resolve({ success: false, status: 403, message: err.response })
                } else {
                    return resolve({ success: false, status: 500, message: err.respons })
                }
            })
    });
};
export function PostRequest(route: string, params: any, authData?: LoginResponse): Promise<ResponseApiApp<any>> {

    return new Promise(resolve => {

        var headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'accept': 'application/json'
        } as any;
        if (authData) {
            headers.authorization = "Bearer " + authData.token;
            headers.uid = authData.customerId;
        }
        const requestOptions = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(params)
        };
        fetch(`${apiUrl}/${route}`, requestOptions)
            .then(response => response.json())
            .then(result => {

                return resolve(result)
            })
            .catch(err => {
                console.log(err)
                if (err.response && err.response.status === 403) {
                    return resolve({ success: false, status: 403, message: err.response })
                } else {
                    return resolve({ success: false, status: 500, message: err.respons })
                }
            })
    });
}
export function PutRequest(route: string, params: any, authData?: LoginResponse): Promise<ResponseApiApp<any>> {

    return new Promise(resolve => {

        var headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'accept': 'application/json'
        } as any;
        if (authData) {
            headers.authorization = "Bearer " + authData.token;
            headers.uid = authData.customerId;
        }
        const requestOptions = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(params)
        };
        fetch(`${apiUrl}/${route}`, requestOptions)
            .then(response => response.json())
            .then(result => {

                return resolve(result)
            })
            .catch(err => {
                console.log(err)
                if (err.response && err.response.status === 403) {
                    return resolve({ success: false, status: 403, message: err.response })
                } else {
                    return resolve({ success: false, status: 500, message: err.respons })
                }
            })
    });
}
export function PutFormRequest(route: string, params: any, authData?: LoginResponse): Promise<ResponseApiApp<any>> {

    return new Promise(resolve => {


        var headers = {
            // 'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
            'accept': '*/*',
        } as any;
        if (authData) {
            headers.authorization = "Bearer " + authData.token;
            headers.uid = authData.customerId;
        }
        const requestOptions = {
            method: 'PUT',
            headers: headers,
            body: params
        };
        fetch(`${apiUrl}/${route}`, requestOptions)
            .then(response => response.json())
            .then(result => {

                return resolve(result)
            })
            .catch(err => {
                console.log(err)
                if (err.response && err.response.status === 403) {
                    return resolve({ success: false, status: 403, message: err.response })
                } else {
                    return resolve({ success: false, status: 500, message: err.respons })
                }
            })
    });
}
export function PostFormRequest(route: string, params: any, authData?: LoginResponse): Promise<ResponseApiApp<any>> {

    return new Promise(resolve => {


        var headers = {
            // 'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
            'accept': '*/*',
        } as any;
        if (authData) {
            headers.authorization = "Bearer " + authData.token;
            headers.uid = authData.customerId;
        }
        const requestOptions = {
            method: 'POST',
            headers: headers,
            body: params
        };
        fetch(`${apiUrl}/${route}`, requestOptions)
            .then(response => response.json())
            .then(result => {

                return resolve(result)
            })
            .catch(err => {
                console.log(err)
                if (err.response && err.response.status === 403) {
                    return resolve({ success: false, status: 403, message: err.response })
                } else {
                    return resolve({ success: false, status: 500, message: err.respons })
                }
            })
    });
}
export function deleteOne(resource: string, params: any, callback: any) {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + const_function.getToken()
    }
    return axios.delete(`${apiUrl}/${resource}`, {
        headers: headers
    })
        .then(result => {
            callback(result.data, 100)
        })
        .catch(err => {
            if (err.response && err.response.status === 403) {
                callback(false, 403)
            } else {
                callback(false, 500)
            }
        })
}



